import { render } from "./EditCustomerGroupModal.vue?vue&type=template&id=563b40ad"
import script from "./EditCustomerGroupModal.vue?vue&type=script&lang=js"
export * from "./EditCustomerGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__